import { render, staticRenderFns } from "./PersonCreate.vue?vue&type=template&id=2f72c630&"
import script from "./PersonCreate.vue?vue&type=script&lang=js&"
export * from "./PersonCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports